export const WORK_EXPERIENCE = [
  {
    title: 'Junior Developer',
    company: 'Price Industries',
    companyUrl: 'https://www.priceindustries.com',
    duration: 'May 2025 - Present',
    location: 'Winnipeg, MB, Canada',
    summary:
      'Developing features for a Configure, Price, Quote (CPQ) software platform that streamlines the sales process for HVAC equipment. The system helps sales representatives generate accurate quotes quickly while managing complex product configurations and pricing rules.',
    description: [
      'Developed features for <strong>CPQ (Configure, Price, Quote)</strong> software serving <strong>2000+ sales representatives</strong> globally, reducing quote generation time by <strong>15%</strong>.',
      'Built and optimized <strong>C# (.NET Core)</strong> backend services with SQL Server integration, improving real-time pricing accuracy by <strong>20%</strong> for specific products.',
      'Implemented responsive <strong>Angular components with TypeScript</strong>, significantly improving user task completion rates and reducing training time for new sales staff.',
    ],
  },
  {
    title: 'Application Developer (Co-op)',
    company: 'Government of Manitoba',
    companyUrl: 'https://www.gov.mb.ca',
    duration: 'Jan 2025 - Apr 2025',
    location: 'Winnipeg, MB, Canada',
    summary:
      'Contributed to the Manitoba Health Card Replacement Application, a digital platform that modernizes the health card application process. The system allows citizens to apply for, renew, and manage their health cards online, significantly reducing processing times and improving accessibility.',
    description: [
      'Worked on Manitoba Health Replacement App using <strong>Microsoft Power Platform (Power Apps)</strong> and <strong>Azure Cloud services</strong>, serving more than <strong>200,000+ Manitobans</strong> who applied for a new health card.',
      'Created <strong>5+ Power Automate workflows</strong> that automated manual data entry processes, saving <strong>20 hours per week</strong> and reducing processing errors by <strong>12%</strong>.',
    ],
  },
  {
    title: 'Full Stack Engineer (Co-op)',
    company: "Elmer's Manufacturing",
    companyUrl: 'https://elmersmfg.com/',
    duration: 'May 2023 - Aug 2024',
    location: 'Winnipeg, MB, Canada',
    summary:
      'Developed a comprehensive tool that helps farmers analyze and track their produce data, providing insights for better crop management. Also worked on microcontroller software for agriculture equipment, enabling automated grain handling and real-time weight monitoring during harvest operations.',
    description: [
      'Developed full-stack features for <strong>2 production applications</strong> using <strong>PHP/Laravel, Python/FastAPI, and Vue.js</strong>, serving <strong>1,000+ daily active users</strong>.',
      'Optimized database performance by implementing transaction batching and <strong>PostgreSQL query optimization</strong>, reducing database load by <strong>24%</strong> and improving response times by <strong>17%</strong>.',
      'Established automated <strong>CI/CD pipeline using Azure DevOps</strong> and xUnit testing, reducing deployment time by <strong>70%</strong> and catching <strong>95% of bugs</strong> before production.',
    ],
  },
  {
    title: 'Teaching Assistant',
    company: 'University of Manitoba',
    companyUrl: 'https://www.umanitoba.ca',
    duration: 'Sep 2022 - Dec 2022',
    location: 'Winnipeg, MB, Canada',
    summary:
      'Assisted in teaching Programming Practices course, helping students understand fundamental programming concepts, memory management, and Unix systems. Provided guidance and feedback to ensure students developed strong programming foundations.',
    description: [
      "Maximized students' potential with curated lessons provided through my understanding and materials prepared with the professor's assistance in <strong>Programming Practices (C)</strong>.",
      "Evaluated students' assignments, midterm exams, and final exams focusing on memory management, testing in C, and Unix systems.",
    ],
  },
];
